const axios = require('axios');
//const CancelToken = axios.CancelToken;

import { LEADS_ADD_URL } from '../components/settings'

function formatDate(date){
  return date ? (date.getMonth() + 1) + '/' + date.getDate() + '/' +  date.getFullYear() : null
}

function createNotes(notes, baths, availFrom, availTo, students, maxRent, beds, pets, locations, ids){
  return [
    notes,
    "\n--Form Data--",
    "Beds: " + beds.join(),
    baths.length > 0 ? "Bathrooms: " + baths.join(", ") : "",
    availTo && availTo !== '' ? "Possible Dates: " + formatDate(availFrom) + " to " + formatDate(availTo) : "Move-in: " + formatDate(availFrom),
    "Max Rent: " + maxRent,
    pets.length > 0 ? "Pets: " + pets.join(", ") : "",
    students.length > 0 ? "Students: " + students.join(", ") : "",
    locations.length > 0 ? "Locations: " + locations.map(str => str.replace("Boston:", "")).join(", ") : "",
    ids.length > 0 ? "Listing IDS: " + ids.join(", ") : ""
  ].filter(str => str !== "").join("\n");
}

export const addLead = function({
  beds = [],
  baths = [],
  availFrom, 
  availTo,
  maxRent,
  pets = [],
  locations = [], ///////////////
  firstName,
  lastName,
  phone,
  email,
  students = [],
  notes,
  ids = []
}){
  return (
    axios.get(LEADS_ADD_URL, {
      timeout: 10000,
      params: {
        beds: beds.join(),
        baths: baths.join(),
        avail_from: availFrom ? formatDate(availFrom) : null,
        avail_to: availTo ? formatDate(availTo) : null, 
        rent_max: maxRent == 0 ? null : maxRent,
        locations: locations.join(),
        first_name: firstName,
        last_name: lastName,
        phone: phone,
        email: email,
        cat: pets.includes("cat") ? "1" : "0",
        dog: pets.includes("dog") ? "1" : "0",
        ids: ids.join(),
        notes: createNotes(notes, baths, availFrom, availTo, students, maxRent, beds, pets, locations, ids)
      }
    })

    // .then(response => {
    //   return response.status == 404;
    // })
    // .catch(error => {
    //   //console.log(error);
    //   return "WHAT?!";
    // })
  )
}
